export default "__VITE_ASSET__D$4Ks1ZJ__"